export default __webpack_public_path__ + "media/zurb/img/product-innovation/firefox_video_screenshot-c97bf3ceefd0723f0e4e1dbf784e4fbe.png";